/**
 * Progress Events — the pipeline's observable stages.
 *
 * Stages mirror the product pipeline one to one so a UI can show exactly
 * where a generation is. Events are plain objects delivered to a callback;
 * no global emitter, no external listeners to leak.
 */

export const STAGES = {
  QUEUED: 'queued',
  THINKING: 'thinking', // provider (LLM) deciding the brief
  CREATIVE_DIRECTION: 'creative-direction',
  TEMPLATE_FACTORY: 'template-factory',
  DESIGN_ENGINE: 'design-engine',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  ERROR: 'error',
};

/** Ordered happy-path stages, for progress bars. */
export const STAGE_ORDER = [
  STAGES.QUEUED,
  STAGES.THINKING,
  STAGES.CREATIVE_DIRECTION,
  STAGES.TEMPLATE_FACTORY,
  STAGES.DESIGN_ENGINE,
  STAGES.COMPLETED,
];

/**
 * Wrap a user callback into a safe emitter.
 * Emitted event: { stage, at: ISO time, ...detail }.
 * A throwing listener never breaks the pipeline.
 */
export const createProgressEmitter = (onProgress) => (stage, detail = {}) => {
  const event = { stage, at: new Date().toISOString(), ...detail };
  try {
    onProgress?.(event);
  } catch { /* observer errors are the observer's problem */ }
  return event;
};
